import { PZN_BLOCK_NAME } from "../../constants/pzn-constants";
import { createUUID } from "./commons";

const markerAttributesLoaders = {
  "helix-common/pzn-container-block": (blockName, block, metaData) => {
    let pznRecObj = null;
    if (blockName === PZN_BLOCK_NAME) {
      metaData.pznRecDetailsArr?.forEach((pznObj) => {
        if (pznObj.personalization_placement === block.accessPoint) {
          pznRecObj = pznObj;
        }
      });
    }

    return pznRecObj
      ? {
          "data-pzn-access-point": pznRecObj?.personalization_placement,
          "data-pzn-offer-id": pznRecObj?.personalization_id,
          "data-pzn-content_id": pznRecObj?.content_id,
          "data-pseudo-experience": "pzn",
          "data-psuedo-block_id": createUUID() //generate random uuid
        }
      : null;
  },
  "gwp-components/reusable-block": (blockName, block, metaData) => {
    let ixpRecObj = null;
    if (blockName === metaData.reusableBlockName) {
      metaData.ixpDetailsArr?.forEach((ixpObj) => {
        if (
          block.props.externalContentIdentifier === ixpObj.original_content_id
        ) {
          ixpRecObj = ixpObj;
        }
      });
    }

    return ixpRecObj
      ? {
          "data-ixp-original-content-id": ixpRecObj?.original_content_id,
          "data-ixp-replacement-id": ixpRecObj?.replacement_content_id,
          "data-pseudo-experience": "ixp",
          "data-psuedo-block_id": createUUID() //generate random uuid
        }
      : null;
  },
  "mds/reusable-blocks": (blockName, block, metaData) => {
    let ixpRecObj = null;
    if (blockName === metaData.reusableBlockName) {
      metaData.ixpDetailsArr?.forEach((ixpObj) => {
        if (
          block.props.externalContentIdentifier === ixpObj.original_content_id
        ) {
          ixpRecObj = ixpObj;
        }
      });
    }

    return ixpRecObj
      ? {
          "data-ixp-original-content-id": ixpRecObj?.original_content_id,
          "data-ixp-replacement-id": ixpRecObj?.replacement_content_id,
          "data-pseudo-experience": "ixp",
          "data-psuedo-block_id": createUUID() //generate random uuid
        }
      : null;
  }
};

/**
 * wrap block with marker
 * @param {*} blockName name of the block
 * @param {*} block payload
 * @param {*} metaData metadata object
 * @param {*} innerBlocks inner blocks
 * @returns block wrapped with marker
 */
export const wrapWithMarker = (blockName, block, metaData, innerBlocks) => {
  if (blockName in markerAttributesLoaders) {
    const markerAttributes = markerAttributesLoaders[blockName](
      blockName,
      block,
      metaData
    );

    return markerAttributes
    ? [
        <gwp-marker-start key="marker-start" {...markerAttributes} />,
        innerBlocks,
        <gwp-marker-end key="marker-end" {...markerAttributes} />
      ]
    : innerBlocks;
  } else {
    return innerBlocks;
  }
};
